import { render, staticRenderFns } from "./class-forward-v1.vue?vue&type=template&id=c91b6438&"
import script from "./class-forward-v1.vue?vue&type=script&lang=js&"
export * from "./class-forward-v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports